import api from "./api"
import { getStoredShipper } from "../constants/utils"

const USER_PROFILE_ROOT = "v2.0/platform"
const USER_PROFILE_ROOT_V3 = "v3.0/platform"
const USER_ACCESS_RIGHTS_ROOT = "v2.0/platform"
const { VITE_APP_WABTEC_ONE_APPLICATION_ID, VITE_APP_EBOL_APPLICATION_ID } =
    import.meta.env
const includeDescription = false
const includeGrantors = true

const userprofileApi = {
    checkEbolAccess() {
        const { SHIPPER } = getStoredShipper()
        let OrgID = SHIPPER && SHIPPER.orgId ? SHIPPER.orgId : ""
        return api.get(
            `${USER_PROFILE_ROOT_V3}/Users?applicationId=${VITE_APP_EBOL_APPLICATION_ID}&orgId=${OrgID}`,
            "USER_PROFILE"
        )
    },
    getOrganizationsData() {
        return api.get(
            `${USER_PROFILE_ROOT}/Organizations?applicationId=${VITE_APP_WABTEC_ONE_APPLICATION_ID}&includeDescription=${includeDescription.toString()}&includeGrantors=${includeGrantors.toString()}`,
            "USER_PROFILE"
        )
    },
    getAccessRightsData(organisationData) {
        let selectedOrgId
        let storedShipperDetails = []
        const { STORED_SHIPPER_NAME, STORED_RAILROAD_NAME } = getStoredShipper()

        if (organisationData !== undefined && organisationData.length > 0) {
            // Contains list of all shippers with grantors, sorted alphabetically by shipper name
            const allShippers = organisationData
                .filter(
                    (item) =>
                        item.orgType === "Shipper" && item.grantors.length > 0
                )
                .sort((a, b) => (a.orgName > b.orgName ? 1 : -1))

            // Based on the stored shipper and railroad names, find the matching shipper details from the list of all shippers with grantors
            storedShipperDetails =
                STORED_SHIPPER_NAME &&
                allShippers.filter(
                    (shipper) =>
                        shipper.orgName === STORED_SHIPPER_NAME &&
                        shipper.grantors[0]["orgName"] === STORED_RAILROAD_NAME
                )

            if (
                storedShipperDetails &&
                Object.keys(storedShipperDetails).length
            ) {
                // If stored shipper details are found, get the matching shipper's latest shipper details and set it in local storage
                selectedOrgId = storedShipperDetails[0].orgId
                localStorage.setItem(
                    "shipper_details",
                    JSON.stringify(storedShipperDetails[0])
                )
            } else if (allShippers.length && allShippers[0].grantors) {
                // Else if no stored shipper details are found, get the first shipper's details from all shippers list and set it in the local storage
                selectedOrgId = allShippers[0].orgId
                localStorage.setItem(
                    "shipper_details",
                    JSON.stringify(allShippers[0])
                )
            } else {
                // If no shipper details are found, set the selectedOrgId to empty string
                selectedOrgId = ""
                console.warn("No shipper details found for the user.")
            }

            return api.get(
                `${USER_ACCESS_RIGHTS_ROOT}/Users?orgId=${selectedOrgId}&applicationId=${VITE_APP_WABTEC_ONE_APPLICATION_ID}`,
                "USER_PROFILE"
            )
        }
    },
}

export default userprofileApi
